import { cn } from '@/lib/utils';
import { Trash2 } from 'lucide-react';
import { useEffect, useRef, useState, type ComponentProps } from 'react';
import { ToastContainer, toast, type Id } from 'react-toastify';

type ToastContainerProps = ComponentProps<typeof ToastContainer>;

const toastColumnClass =
	'w-full max-w-[min(100%,var(--toastify-toast-width,320px))]';

export function ToastStackWithDismissAll(props: ToastContainerProps) {
	const [activeCount, setActiveCount] = useState(0);
	const activeIdsRef = useRef(new Set<Id>());

	useEffect(() => {
		const unsubscribe = toast.onChange((item) => {
			if (item.status === 'added') {
				activeIdsRef.current.add(item.id);
				setActiveCount(activeIdsRef.current.size);
			}
			if (item.status === 'removed') {
				activeIdsRef.current.delete(item.id);
				setActiveCount(activeIdsRef.current.size);
			}
		});
		return unsubscribe;
	}, []);

	const dismissAll = () => {
		activeIdsRef.current.clear();
		setActiveCount(0);
		toast.dismiss();
	};

	const { style: containerStyle, className, ...rest } = props;

	return (
		<div className="pointer-events-none fixed right-4 top-4 z-[99999] flex max-w-[calc(100vw-2rem)] flex-col items-end gap-1.5 max-[420px]:right-2 max-[420px]:top-2">
			<div
				className={cn(
					'pointer-events-auto flex flex-col gap-1.5',
					toastColumnClass,
				)}
			>
				<ToastContainer
					{...rest}
					className={className}
					style={{
						...containerStyle,
						position: 'static',
						zIndex: 'auto',
					}}
				/>
				{activeCount > 0 ? (
					<button
						type="button"
						title="Limpar todas as notificações"
						className={cn(
							'group flex w-full shrink-0 items-center justify-center gap-2 rounded-lg',
							'border border-stone-200 bg-white',
							'px-3 py-2.5 text-sm font-medium text-stone-600',
							'shadow-[0_4px_12px_rgba(0,0,0,0.1)]',
							'transition-colors hover:bg-rose-50 hover:text-rose-600 active:bg-rose-100/60',
							'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-stone-400/50',
						)}
						onClick={dismissAll}
					>
						<Trash2
							size={16}
							className="shrink-0 text-stone-400 transition-colors group-hover:text-rose-600"
							aria-hidden
						/>
						Limpar tudo
					</button>
				) : null}
			</div>
		</div>
	);
}
